import {
  FETCH_SENTIMENT_BEGIN,
  FETCH_SENTIMENT_SUCCESS,
  FETCH_SENTIMENT_FAILURE,
  FETCH_BATCH_SENTIMENT_BEGIN,
  FETCH_BATCH_SENTIMENT_SUCCESS,
  FETCH_BATCH_SENTIMENT_FAILURE,
} from './sentimentActions';

const initialState = {
  sentimentData: {},       // For single ticker
  batchSentimentData: [],  // Flat array for batch results
  loading: false,
  batchLoading: false,
  error: null,
  batchError: null,
};

export const sentimentReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SENTIMENT_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_SENTIMENT_SUCCESS: {
      const payload = action.payload;
      let articles = [];

      // Accepts either a plain array, or an object with .results
      if (Array.isArray(payload)) {
        articles = payload;
      } else if (Array.isArray(payload.results)) {
        articles = payload.results;
      }

      return {
        ...state,
        loading: false,
        sentimentData: {
          articles,
          total_articles: articles.length,
          last_updated: new Date().toISOString(),
        },
      };
    };
    case FETCH_SENTIMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    // === BATCH CASES ===
    case FETCH_BATCH_SENTIMENT_BEGIN:
      return {
        ...state,
        batchLoading: true,
        batchError: null,
      };
    case FETCH_BATCH_SENTIMENT_SUCCESS:
      // FIX: Ensure payload is an array and handle empty responses
      const batchData = Array.isArray(action.payload) ? action.payload : [];
      //console.log('Batch sentiment data received:', batchData); // Debug log
      return {
        ...state,
        batchLoading: false,
        batchSentimentData: batchData,
        // Add metadata for debugging
        batchMetadata: {
          total_articles: batchData.length,
          last_updated: new Date().toISOString(),
          tickers: [...new Set(batchData.map(article => article.ticker))],
        },
      };
    case FETCH_BATCH_SENTIMENT_FAILURE:
      return {
        ...state,
        batchLoading: false,
        batchError: action.payload,
        batchSentimentData: [], // Clear data on error
      };
    default:
      return state;
  }
};